import styles from './skeletons.module.css';

/**
 * Phase 5 PR 5.1 — placeholder for `<WeekPlan />` while
 * `useWeeklyPlan` resolves.
 *
 * Renders 7 neutral day cells matching WeekPlan's grid dimensions.
 */
export function WeekPlanSkeleton() {
  return (
    <div
      className={styles.week}
      role="status"
      aria-busy="true"
      aria-label="Loading this week's plan"
    >
      {[0, 1, 2, 3, 4, 5, 6].map((i) => (
        <div key={i} className={styles.weekDay} aria-hidden>
          <span className={`${styles.bar} ${styles.weekDayShort}`} />
          <span className={`${styles.bar} ${styles.weekDayLabel}`} />
          <span className={`${styles.bar} ${styles.weekDayValue}`} />
        </div>
      ))}
    </div>
  );
}
